import { render, staticRenderFns } from "./ApproversDetail.vue?vue&type=template&id=2853db9c&"
import script from "./ApproversDetail.vue?vue&type=script&lang=js&"
export * from "./ApproversDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports